import React  from "react";
import Modal from 'react-bootstrap/Modal'
import Fitdownload from "../../components/utils/Fitdownload";

export default function ModalFitDownload(props) {

    return (<Fitdownload callbackToShowModal={props.callbackToShowModal} />);
}
